import { faMoon, faSunBright } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useState } from 'react'
import './ThemeSwitcher.scss'
import { ThemeContext } from '../../context/theme-context';

export default function ThemeSwitcher() {
    const { theme, setTheme } = useContext(ThemeContext);
    const [isDark, setisDark] = useState(false);

    const handleThemeChange = () => {
        const isCurrentDark = theme === 'dark';
        if (isCurrentDark) {
            setisDark(true)
        }
        else {
            setisDark(false)
        }
        setTheme(isCurrentDark ? 'light' : 'dark');
        localStorage.setItem('default-theme', isCurrentDark ? 'light' : 'dark');
    };
    return (

        <>
            <div className='themeswitcher-icon-wrapper' onClick={() => handleThemeChange()}>


                {!isDark &&
                    <FontAwesomeIcon icon={faSunBright} />
                }

                {isDark &&
                    <FontAwesomeIcon icon={faMoon} />
                }


            </div>
        </>
    )
}
